// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "(max-width: 1024px) and (min-width: 601px)";
var _4 = "screen and (max-width: 600px)";
var _5 = "actions-k0PeL";
var _6 = "addSegment-314V_";
var _7 = "removeSegment-1NxWE";
var _8 = "actions_alternative-38Nao";
var _9 = "addSegment_alternative-1a4t9";
var _a = "removeSegment_alternative-2BWJq";
export { _1 as "__esModule", _2 as "tablet", _3 as "tablet_only", _4 as "mobile", _5 as "actions", _6 as "addSegment", _7 as "removeSegment", _8 as "actions_alternative", _9 as "addSegment_alternative", _a as "removeSegment_alternative" }
export default { "__esModule": _1, "tablet": _2, "tablet_only": _3, "mobile": _4, "actions": _5, "addSegment": _6, "removeSegment": _7, "actions_alternative": _8, "addSegment_alternative": _9, "removeSegment_alternative": _a }
